import React, {ReactNode} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

type EmptyStateProps = {
    wrapperClasses?: string;
    containerClasses?: string;
    title?: ReactNode;
    icon?: ReactNode;
    wrapperStyle?: React.CSSProperties;
};

export const EmptyState = ({
    wrapperClasses,
    icon,
    title,
    wrapperStyle,
    containerClasses
}: EmptyStateProps) => {
    return (
        <div
            className={cx(styles.wrapper, wrapperClasses)}
            style={wrapperStyle}
            data-test-id="empty-state"
        >
            <div className={cx(styles.container, containerClasses)}>
                {icon}
                {title}
            </div>
        </div>
    );
};
